import { SubmitHandler, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button, SubmitButton } from "@/components/Interface/Button/Button";
import { CardModule } from "@/components/Layout/BaseLayouts/CardModule/CardModule";
import { NumberForm } from "@/hooks/useNumberForm";

import {
  stepDescriptionClassName,
  stepHeadingClassName,
} from "./authenticator.utils";
import { AuthenticatorPhoneNumberField } from "./AuthenticatorPhoneNumberField";

export const AuthenticatorSmsSetupForm = ({
  formMethods,
  onSubmit,
}: {
  formMethods: UseFormReturn<NumberForm, any, NumberForm>;
  onSubmit: SubmitHandler<NumberForm>;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <form onSubmit={formMethods.handleSubmit(onSubmit)}>
      <CardModule
        stickyHeader
        title={t("portal:user-account.security.2fa.initialSetup.title")}
        actions={
          <>
            <Button
              variant="secondary"
              size="sm"
              type="button"
              onClick={() => navigate(-1)}
            >
              {t("Common.label.cancel")}
            </Button>
            <SubmitButton
              fullWidth={false}
              size="sm"
              label={t("portal:authenticator.sms.enterNumber.sendCode")}
            />
          </>
        }
      >
        <div className="flex flex-col gap-4">
          <h3 className={stepHeadingClassName}>
            {t("portal:authenticator.sms.enterNumber.title")}
          </h3>
          <p className={stepDescriptionClassName}>
            {t("portal:authenticator.sms.enterNumber.description")}
          </p>
          <AuthenticatorPhoneNumberField
            register={formMethods.register}
            errors={formMethods.formState.errors}
          />
        </div>
      </CardModule>
    </form>
  );
};
